import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

function ProfileIcon(props) {
  return (
    <Svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Circle cx={16} cy={16} r={16} fill="#F3F5FC" />
      <Path
        d="M16 15.977c-.977 0-1.777-.31-2.4-.933-.622-.622-.933-1.422-.933-2.4s.311-1.778.933-2.4c.623-.622 1.423-.933 2.4-.933.978 0 1.778.31 2.4.933.623.622.934 1.422.934 2.4s-.311 1.778-.934 2.4c-.622.622-1.422.933-2.4.933zm5.778 7.133H10.223c-.37 0-.686-.13-.945-.388a1.286 1.286 0 01-.389-.945v-.755c0-.563.14-1.045.422-1.445a2.71 2.71 0 011.09-.91 16.705 16.705 0 012.855-1A11.545 11.545 0 0116 17.332c.919 0 1.83.115 2.734.344.903.23 1.851.56 2.844.99.46.206.83.51 1.111.91.282.4.422.882.422 1.445v.755c0 .37-.13.685-.389.945-.259.259-.574.388-.944.388zm-11.555-1.333h11.555v-.755c0-.237-.07-.463-.211-.678a1.338 1.338 0 00-.522-.478c-.948-.46-1.815-.774-2.6-.944-.785-.17-1.6-.256-2.445-.256-.844 0-1.666.085-2.466.256-.8.17-1.667.485-2.6.944a1.262 1.262 0 00-.511.478c-.134.215-.2.44-.2.678v.755zM16 14.644c.578 0 1.056-.189 1.434-.567.377-.378.566-.855.566-1.433 0-.578-.189-1.056-.566-1.434-.378-.377-.856-.566-1.434-.566s-1.055.189-1.433.566c-.378.378-.567.856-.567 1.434s.19 1.055.567 1.433c.378.378.855.567 1.433.567z"
        fill={props?.color || "#1434CB"}
      />
    </Svg>
  );
}

export default ProfileIcon;
